const validator = require('./validator').validator;
const inOutFormatDecorator = require('./validator').inOutFormatDecorator;

const userAgent = {
    type: 'string',
    presence: false,
    length: {
        maximum: 256
    }
};

const integerType = {
    presence: false,
    numericality: {
        onlyInteger: true
    }
};

const floatType = {
    presence: false,
    numericality: {
        strict: true
    }
};

const ip = {
    type: 'Ip',
    presence: false,
    length: {
        minimum: 1,
        maximum: 46 // ipv6 address
    }
};

const appVersion = {
    type: 'string',
    presence: false,
    length: {
        maximum: 25
    }
};

const pagePreview = {
    rbk: { type: 'string', presence: false },
    userId: {
        type: 'string',
        presence: false,
        length: {
            minimum: 17,
            maximum: 36
        }
    },
    sessionId: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    url: {
        type: 'string',
        presence: false,
        length: {
            maximum: 2046
        }
    },
    path: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    pageVisitId: {
        type: 'string',
        presence: false,
        length: {
            maximum: 20
        }
    },
    requestMethod: {
        type: 'string',
        presence: false,
        length: {
            maximum: 15
        }
    },
    host: {
        type: 'string',
        presence: false,
        length: {
            maximum: 128
        }
    },
    protocol: {
        type: 'string',
        presence: false,
        length: {
            maximum: 10
        }
    },
    agent: userAgent,
    previousPath: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    browser: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    browserVersion: {
        type: 'string',
        presence: false,
        length: {
            maximum: 10
        }
    },
    device: {
        type: 'string',
        presence: false,
        length: {
            maximum: 10
        }
    },
    os: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    osVersion: {
        type: 'string',
        presence: false,
        length: {
            maximum: 35
        }
    },
    engine: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    architecture: {
        type: 'string',
        presence: false,
        length: {
            maximum: 8
        }
    },
    vendor: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    httpVersion: {
        type: 'string',
        presence: false,
        length: {
            maximum: 6
        }
    },
    ip,
    hash: {
        type: 'string',
        presence: false,
        length: {
            maximum: 60
        }
    },
    refCanonical: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    sessionLandingPage: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    testName: {
        type: 'string',
        presence: false,
        length: {
            maximum: 2046
        }
    },
    reftype: {
        type: 'string',
        presence: false,
        length: {
            maximum: 15
        }
    },
    appVersion,
    querySize: integerType,
    bodySize: integerType,
    viewPortWidth: integerType,
    viewPortHeight: integerType,
    responseCode: integerType,
    sessionStartTime: integerType,
    sessionLastInteraction: integerType,
    sessionCount: integerType,
    isClientSideNavigation: { type: 'boolean', presence: false },
    isNoFollow: { type: 'boolean', presence: false },
    isNoIndex: { type: 'boolean', presence: false },
    isOnline: { type: 'boolean', presence: false },
    privileged: { type: 'boolean', presence: false },
    bot: { type: 'boolean', presence: false },
    referer: { type: 'string', presence: false },
    view: { type: 'string', presence: false },
    site: { type: 'string', presence: false },
    grp: { type: 'string', presence: false }
};

const pagePreviewRUM = {
    rbk: { type: 'string', presence: false },
    userId: {
        type: 'string',
        presence: false,
        length: {
            minimum: 17,
            maximum: 36
        }
    },
    sessionId: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    path: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    pageVisitId: {
        type: 'string',
        presence: false,
        length: {
            maximum: 20
        }
    },
    isClientSideNavigation: { type: 'boolean', presence: false },
    refCanonical: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    sessionStartTime: integerType,
    sessionLastInteraction: integerType,
    sessionCount: integerType,
    sessionLandingPage: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    isNoFollow: { type: 'boolean', presence: false },
    isNoIndex: { type: 'boolean', presence: false },
    isOnline: { type: 'boolean', presence: false },
    connectEnd: integerType,
    connectStart: integerType,
    decodedBodySize: integerType,
    domComplete: integerType,
    domContentLoadedEventStart: integerType,
    domContentLoadedEventEnd: integerType,
    domInteractive: integerType,
    domainLookupStart: integerType,
    domainLookupEnd: integerType,
    duration: integerType,
    encodedBodySize: integerType,
    fetchStart: integerType,
    initiatorType: {
        type: 'string',
        presence: false
    },
    loadEventEnd: integerType,
    loadEventStart: integerType,
    requestStart: integerType,
    responseStart: integerType,
    responseEnd: integerType,
    secureConnectionStart: integerType,
    unloadEventStart: integerType,
    unloadEventEnd: integerType,
    transferSize: integerType,
    firstPaint: integerType,
    firstContentfulPaint: integerType,
    navigationType: {
        type: 'string',
        presence: false
    },
    dwellTime: integerType,
    requestMethod: {
        type: 'string',
        presence: false,
        length: {
            maximum: 15
        }
    },
    reftype: {
        type: 'string',
        presence: false,
        length: {
            maximum: 15
        }
    },
    agent: userAgent,
    referer: { type: 'string', presence: false },
    view: { type: 'string', presence: false },
    site: { type: 'string', presence: false },
    bot: { type: 'boolean', presence: false },
    grp: { type: 'string', presence: false }
};

const interaction = {
    visitorHash: { type: 'string', presence: false },
    userId: {
        type: 'string',
        presence: false,
        length: {
            minimum: 17,
            maximum: 36
        }
    },
    sessionId: {
        type: 'string',
        presence: false,
        length: {
            maximum: 25
        }
    },
    pageUrl: {
        type: 'string',
        presence: false,
        length: {
            maximum: 2046
        }
    },
    eventCategory: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    eventAction: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    eventLabel: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    eventValue: floatType,
    eventTestName: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    ip,
    userAgent,
    arbitrary1: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    arbitrary2: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    arbitrary3: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    arbitrary4: {
        type: 'string',
        presence: false,
        length: {
            maximum: 256
        }
    },
    appVersion
};

module.exports = {
    pagePreview: {
        schema: pagePreview,
        validate: inOutFormatDecorator(validator, pagePreview)
    },

    pagePreviewRUM: {
        schema: pagePreviewRUM,
        validate: inOutFormatDecorator(validator, pagePreviewRUM)
    },

    interaction: {
        schema: interaction,
        validate: inOutFormatDecorator(validator, interaction)
    }
};
